import  axiosI  from '../Service/service';
import { GET_CHART_DETAIL } from './actionTypes';
import * as constants from '../Constants';

  export const GetChartDetail=(placeID,userId,startDate,endDate,isAllTime)=>{
  return (dispatch => {
    return axiosI.post(constants.API.getCheckinDealClaimedCountApi,{"PlaceId":placeID,"UserId":userId,"StardDate":startDate,"EndDate":endDate,"isAllTime":isAllTime}).then(({data})=>{
      dispatch({
        type: GET_CHART_DETAIL,
        payload: data.results
      });
    })
  })
};
